import { ISelectInputProps, SelectInput } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { useMemo } from 'react';
import { useCommunicationsContext } from '../context/CommunicationsContext';

export interface ICommunicationSearchableTypeSelectInputProps
  extends ISelectInputProps {}

export function CommunicationSearchableTypeSelectInput(
  props: ICommunicationSearchableTypeSelectInputProps,
) {
  const { ...otherProps } = props;
  const { searchableTypes } = useCommunicationsContext();
  const { t } = useTranslation();

  const options = useMemo(() => {
    return searchableTypes?.map(type => ({
      label: type.codice ?? '',
      value: type.id!,
    }));
  }, [searchableTypes]);

  return (
    <SelectInput
      options={options}
      allowClear
      placeholder={t(
        'communication-searchable.search-by-type',
        'Seleziona il tipo...',
      )}
      {...otherProps}
    />
  );
}
